export default __webpack_public_path__ + "images/man_people_person.svg";